import { render, staticRenderFns } from "./radio-free.vue?vue&type=template&id=0d84860b&"
import script from "./radio-free.vue?vue&type=script&lang=js&"
export * from "./radio-free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports